// components/common/WarningBanner.tsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

interface WarningBannerProps {
    message: string;
}

export const WarningBanner: React.FC<WarningBannerProps> = ({ message }) => (
    <div className='lending-limits-warning-banner'>
        <FontAwesomeIcon
            icon={faWarning}
            style={{ marginRight: '.5rem', color: '#856404' }}
        />
        {message}
    </div>
);
